import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

export interface IExtractedValue {
    section: string;
    key: string;
    label: string;
    value: string;
    sheet: string;
    cell: string;
    confidence: string | null;
    cannotLocate: boolean;
}

export interface IExtractedBudgetPeriod {
    period: string;
    value: string;
}

export interface IExtractedBudgetRow {
    bucket: string;
    name: string;
    total: string;
    periods: IExtractedBudgetPeriod[];
    sheet: string;
    cell: string;
    noItemsFound: boolean;
}

export interface IFullExtractionResult {
    mode?: undefined;
    extracted: IExtractedValue[];
}

export interface IBudgetExtractionResult {
    mode: 'budget';
    extracted: IExtractedBudgetRow[];
}

export type IExtractionResult = IFullExtractionResult | IBudgetExtractionResult;

export interface IExtractionTaskResponse {
    taskId: string;
}

interface IParams {
    organizationUuid: string;
    dealId: number;
    objectKey: string;
    budgetOnly: boolean;
}

const enqueueProFormaExtraction = async ({
    organizationUuid, dealId, objectKey, budgetOnly,
}: IParams): Promise<IExtractionTaskResponse> => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.UPLOADED_PRO_FORMAS_EXTRACT(organizationUuid, dealId),
        { objectKey, budgetOnly },
    );
    return response.data;
};

export const useExtractProFormaValues = () => useMutation({
    mutationFn: enqueueProFormaExtraction,
});

export default useExtractProFormaValues;
